// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ALTy","messages":"Chat_messages__x_RBQ","dateDivider":"Chat_dateDivider__2TcLw"};